<template>
    <vx-card>
      <div class="vx-row">
        <div class="vx-col w-full mb-2">

          <vs-tabs position="left" class="virtual-class--bottom-panel">

            <vs-tab
              :label="$t('profile.profile-info.title')"
              icon-pack="feather" icon="icon-user">
              <general-profile></general-profile>
            </vs-tab>

            <vs-tab
              :label="$t('profile.reset-password')"
              icon-pack="feather" icon="icon-lock">
              <reset-password></reset-password>
            </vs-tab>

          </vs-tabs>

        </div>

      </div>


    </vx-card>
</template>

<script>
import GeneralProfile from "./component/GeneralProfile";
import ResetPassword from "./component/ResetPassword";

export default {
  components:{
    GeneralProfile,
    ResetPassword,
  },
}

</script>

